import { render, staticRenderFns } from "./W4.vue?vue&type=template&id=0be44ab6&scoped=true&"
import script from "./W4.vue?vue&type=script&lang=js&"
export * from "./W4.vue?vue&type=script&lang=js&"
import style0 from "./W4.vue?vue&type=style&index=0&id=0be44ab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be44ab6",
  null
  
)

export default component.exports